exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".growl[data-v-2e24685a]{background-color:rgba(0,0,0,.7);border-radius:8px 0 0 8px;color:#fff;font-weight:600;padding:10px 16px;position:fixed;right:0;top:120px;z-index:9999}.growl i[data-v-2e24685a]{vertical-align:middle}@media (max-width:768px){.growl[data-v-2e24685a]{background-color:#333;bottom:0;border-radius:0;padding:16px;top:auto;width:100%}}", ""]);

// exports
